export const getLoggedInCookie = () => {
    return getCookie('SPCSSO');
};

export const getCookie = (name: string) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : undefined;
};